import type { CreateOfferCargoFormSchemaType } from "@/pages/admin-cargo-create/model/validation";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import {
  AccordionDetails,
  Autocomplete,
  CircularProgress,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";
import { type Control, Controller } from "react-hook-form";

export const CompanyForm = ({
  control,
  companies,
}: {
  control: Control<CreateOfferCargoFormSchemaType>;
  companies: FreightMatching.schemas.Company[] | null;
}) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>荷主</BaseAccordionSummary>
      <AccordionDetails>
        <BaseFormLabel label="" isRequired sx={{ maxWidth: "376px" }}>
          <Controller
            name="companyId"
            control={control}
            render={({ field, fieldState }) => (
              <FormControl fullWidth error={fieldState.invalid} size="small">
                {companies === null ? (
                  <CircularProgress size={20} />
                ) : (
                  <Autocomplete
                    {...field}
                    value={
                      companies.find((company) => company.id === field.value) ||
                      null
                    }
                    onChange={(_, newValue) => {
                      field.onChange(newValue?.id || null);
                    }}
                    options={companies}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={fieldState.invalid}
                        placeholder="荷主を選択してください"
                      />
                    )}
                  />
                )}
                {fieldState.error && (
                  <FormHelperText>{fieldState.error.message}</FormHelperText>
                )}
              </FormControl>
            )}
          />
        </BaseFormLabel>
      </AccordionDetails>
    </BaseAccordion>
  );
};
